export function getObjectFromVertex(vertex){
      const objectFromVertex = { id : vertex.id};

      const propObject = vertex.props;
      Object.keys(propObject).forEach(function(key){
          if (key !== "addOnMetaData"){
            objectFromVertex[key] = propObject[key];
          }
      })

      return objectFromVertex;
}